<template>
  <div class="table-wrapper">
    <v-progress-linear v-show="loading" :indeterminate="true" :active=loading color="#1fabe2"></v-progress-linear>
    <reserves-visor-component ref="reservesVisor" :eventPromotion="eventPromotion" :promotionId="promotion.id" :dealership="dealership" v-on:close="dialogClosed" ></reserves-visor-component>
    <div style="width: 100%;" v-on:click="fetchSlots">
      <v-btn color="#1fabe2" dark :style="{marginBottom: '0px', float: 'right', display: 'inline-block'}">Actualizar datos<v-icon dark right>refresh</v-icon></v-btn>
    </div>
    <v-layout>
      <v-flex lg12 sm12 xs12 class="text-center">
        <h3>{{ todayDate.format('MMMM') }}</h3>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-sheet>
          <v-calendar
              ref="calendar"
              :now="today"
              :value="today"
              :interval-format="intervalFormat"
              :first-interval="firstInterval"
              locale="es-es"
              :interval-minutes="promotion.slotDuration"
              :show-interval-label="checkHidden"
              :interval-height="intervalHeight"
              :interval-count="intervalCount"
              :weekdays="[1, 2, 3, 4, 5, 6, 0]"
              type="4day">

            <!--suppress HtmlUnknownAttribute -->
            <template
                slot="dayBody"
                slot-scope="{ date, time, hour, minute, timeToY, minutesToPixels, hasTime }">
              <template v-for="(eventPromotion, index) in slotsMap[date]">
                 <!--timed events -->
                  <!--suppress JSUnresolvedVariable -->
                <div
                  :key="`cell_${date}_${eventPromotion.time}_${index}`"
                  :style="{ top: (calculateOffsetFromCurrentAndEvent(timeToY, eventPromotion.time, eventPromotion)) + 'px', height: minutesToPixels(eventPromotion.duration) + 'px' }"
                  class="my-event with-time"
                  v-on:click="openEventsModal(eventPromotion)"
                  :class="{ 'event-full': eventPromotion.quantity === eventPromotion.reserves.length }"
                >
                  ({{ eventPromotion.time }} - {{ eventPromotion.timeTo }})
                  <span v-show="hasPendingProcessed(eventPromotion.reserves)" style="color: red"><v-icon small color="red">notifications</v-icon> </span>
                  <span><!--suppress JSUnresolvedVariable -->
                    <b>{{eventPromotion.quantity - eventPromotion.reserves.length}} huecos libres</b>
                  </span>
                </div>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>

    <v-layout>

      <template>
        <v-card :style="{width: '100%', marginTop: '40px'}">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
          ></v-text-field>
          </v-card-title>

          <v-data-table
              :style="{width: '100%'}"
              :headers="headers"
              :search="search"
              :items="reserves"
              :rows-per-page-items="[10,25,{text:'Todos',value:-1}]"
              rows-per-page-text="Registros por página:"
              class="elevation-1"
              :pagination.sync="paginationSync">
            <!--:rows-per-page-items="[-1]"-->

            <!--suppress HtmlUnknownAttribute -->
            <template slot="items" slot-scope="props" :style="{width: '100%'}">
              <td>{{ props.item.date }}</td>
              <td class="text-xs-left">{{ props.item.time }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.mail }}</td>
              <td class="text-xs-left">{{ props.item.phone }}</td>
              <td class="text-xs-left">{{ props.item.campaign !== null ? props.item.campaign.name : 'No definido' }}</td>
              <td class="text-xs-left">{{ props.item.dealer }}</td>
              <td class="text-xs-left">{{ props.item.note }}</td>
              <!--<td class="text-xs-left"  :style="{backgroundColor: 'inherit'}"><span v-if="props.item.status !== null && props.item.status.id === 'NO_CONTACTADO'" style="color: red"><v-icon small color="red">notifications</v-icon></span><span v-else>{{ props.item.status.name }}</span>-->
              <td class="text-xs-left"><span v-if="props.item.status !== null && props.item.status.id === 'NO_CONTACTADO'" style="color: red"><v-icon small color="red">notifications</v-icon>No contactado</span><span v-else>{{ props.item.status.name }}</span>
              <td class="text-xs-left">{{ props.item.intencion != null ? props.item.intencion : 'No definido' }}</td>
              <td class="text-xs-left">{{ props.item.result != null ? props.item.result : 'No definido' }}</td>
              <td class="text-xs-left"><span>{{ props.item.created }}</span></td>

            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-layout>
  </div>
</template>

<!--suppress JSValidateTypes -->
<script>
import WebService from '@/utils/webservice'
import moment from 'moment'
import ReservesVisorComponent from '@/components/custom/ReservesVisorComponent'

export default {
  name: 'PromotionSlotsTableComponent',
  components: {ReservesVisorComponent},
  props: ['promotion', 'dealership'],

  data () {
    return {
      slots: [],
      days: [],
      dialog: false,
      eventPromotion: null,
      paginationSync: { descending: true, sortBy: 'created' },
      loading: false,
      search: null,
      // Shoot
      headers: [
        {
          text: 'Fecha', value: 'date'
        },
        {
          text: 'Hora', value: 'time'
        },
        {
          text: 'Nombre', value: 'name', sortable: true
        },
        {
          text: 'Email', value: 'mail', sortable: false
        },
        {
          text: 'Telefono', value: 'phone', sortable: false
        },
        {
          text: 'Campaña', value: 'campaign', sortable: true
        },
        { text: 'Comercial asignado', value: 'dealer', sortable: true },
        { text: 'Nota', value: 'note', sortable: false },
        {
          text: 'Estado', value: 'status', sortable: false
        },
        {
          text: 'Intención', value: 'intencion', sortable: false
        },
        {
          text: 'Resultado', value: 'result', sortable: false
        },
        {
          text: 'Fecha creación lead', value: 'created'
        }
      ]
    }
  },

  computed: {
    cutLast () {
      return this.slots[0]
    },

    todayDate () {
      return this.promotion !== null ? moment(this.promotion.startDay * 1000) : moment()
    },

    today () {
      return this.promotion !== null ? moment(this.promotion.startDay * 1000).format(`YYYY-MM-DD HH:mm:ss`) : moment().format(`YYYY-MM-DD HH:mm:ss`)
    },

    slotsMap () {
      const map = {}
      const duration = this.promotion.slotDuration

      for (const slot of this.slots) {
        let date = moment(slot.slot).locale('es-es').format('YYYY-MM-DD')
        let time = moment(slot.slot).locale('es-es').format('HH:mm')
        let timeTo = moment(slot.slot).add(this.promotion.slotDuration, 'minutes').locale('es-ES').format('HH:mm')
        let mapDate = map[date] = map[date] || []

        slot.date = date
        slot.time = time
        slot.timeTo = timeTo
        slot.duration = duration
        slot.slot = moment(slot.slot)
        mapDate.push(slot)
      }

      return map
    },

    reserves () {
      let box = []
      this.slots.forEach(slot => {
        slot.reserves.forEach(reserve => {
          let dateTime = moment(slot.slot)
          box.push({
            date: dateTime.format('DD-MM-YYYY'),
            time: dateTime.format('HH:mm'),
            name: reserve.name,
            mail: reserve.mail,
            phone: reserve.phone,
            campaign: reserve.leadSource,
            status: reserve.status,
            intencion: reserve.intencion,
            result: reserve.result,
            dealer: reserve.dealer.alias,
            note: reserve.note,
            created: moment(reserve.created).locale('es-es').format('DD/MM/YYYY HH:mm'),
            // processed: reserve.status.id !== 'NO_CONTACTADO',
            source: reserve.source
          })
        })
      })
      return box
    },

    firstInterval () {
      let initialForHourly = 10
      if (this.slots.length > 0) {
        initialForHourly = parseInt(moment(this.slots[0].slot).format('HH'))
      }

      return this.promotion.slotDuration === 30 ? 18 : initialForHourly
    },
    intervalHeight () {
      return this.promotion.slotDuration === 30 ? 20 : 40
    },
    intervalCount () {
      return this.promotion.slotDuration === 30 ? 24 : 11
    }
  },

  watch: {
    promotion: () => {
      if (this.dealership !== null) {
        if (this.fetchSlots !== null && this.fetchSlots !== undefined) {
          this.fetchSlots()
        }
      }
    },

    dealership () {
      if (this.promotion !== null) {
        if (this.fetchSlots !== null && this.fetchSlots !== undefined) {
          this.fetchSlots()
        }
      }
    }
  },

  methods: {

    calculateOffsetFromCurrentAndEvent (timeToY, slotTime, eventPromotion) {
      if (this.promotion.slotDuration === 30) {
        console.log('slotTime: ' + slotTime)
        console.log('eventPromotion.slot.toDate().getMinutes(): ' + eventPromotion.slot.toDate().getMinutes())
        return timeToY(slotTime)
      }
      return timeToY(slotTime)
    },

    checkHidden () {
      return true
    },

    intervalFormat (ts) {
      return ts.time
    },

    dialogClosed () {
      // this.$emit('refreshDealerships')
      this.fetchSlots()
    },

    hasPendingProcessed (reserves) {
      return reserves.filter(r => r.status.id === 'NO_CONTACTADO').length > 0
    },

    openEventsModal (eventPromotion) {
      this.eventPromotion = eventPromotion
      this.$refs.reservesVisor.open(eventPromotion)
    },

    // calendarPrev () {
    //   this.todayDate = this.todayDate.subtract(1, 'week')
    //   this.today = this.todayDate.format('YYYY-MM-DD')
    // },
    // calendarNext () {
    //   this.todayDate = this.todayDate.add(1, 'week')
    //   this.today = this.todayDate.format('YYYY-MM-DD')
    // },

    fetchSlots () {
      this.loading = true
      if (this.promotion !== null && this.dealership !== null) {
        WebService.promotions.findSlotsByPromotionAndDealership(this.promotion.id, this.dealership.id).then(slots => {
          this.slots = slots
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },

  mounted () {
    // this.$refs.calendar.scrollToTime('08:00')
  }
}
</script>

<style scoped lang="scss">
  .table-wrapper {
    padding: 20px;
  }

  .table-striped>tbody>tr:nth-of-type(odd) {
  }

  .slots, .reserve_list {
    list-style: none;
    padding-left: 0;
  }

  .slots li:nth-of-type(odd) {
    background-color: #f9f9f9;
  }

</style>

<style lang="scss" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #6dc158;
    color: #ffffff;
    border: 1px solid #898989;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

  &.with-time {
     position: absolute;
     right: 4px;
     margin-right: 0;
   }
  }

  .event-full {
    background-color: #ff7676;
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/promotions/PromotionSlotsTableComponent.vue